<template>
	<div>
		<CModal title="Ajouter une palette" size="lg" :show.sync="showModal">
			<form ref="mainForm" action="/api/pallets" method="post" axiosMethod="post">
				<FormContent v-if="showModal" key="add" />
			</form>

			<template #footer>
				<CButton color="secondary" v-on:click="showModal = false">Annuler</CButton>
				<CButton color="success" v-on:click="onSubmit($refs.mainForm)">Ajouter</CButton>
			</template>
		</CModal>
	</div>
</template>

<script>
	import FormContent from './PalletForm';

	export default {
		components: {
			FormContent,
		},
		data() {
			return {
				showModal: false,
			};
		},

		methods: {
			onSubmit: function (form) {
				this.$formDataToApi.sendForm(form).then(res => {
					if (res.status === 200 || res.status === 201) {
						this.$toast.success('Nouvelle palette créé avec succès !');
						this.showModal = false;
						this.$emit('refresh');
					} else {
						this.$toast.error(res.data['hydra:description']);
					}
				});
			},
		},
	};
</script>
